import React from 'react'
import './CreatorCollection.css'
import logo from '../../../assets/img/logo.png'
import { DoneAll, SearchSharp, MoreHoriz, HourglassEmptyRounded } from '@material-ui/icons'
import Modal from 'react-modal'
import axios from 'axios'

import * as firebase from "firebase/app"
import "firebase/auth"

import { API_URL } from '../../../config'
import { themeColors } from '../../../constants'
import CollectionPayge from '../../CollectionPayge/CollectionPayge'

const yt_modal_styles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		width: '60%',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		padding: 0,
		background: '#0091EA',
		borderRadius: 0,
	}
}

// API setups
const DRIVE_API_KEY = "AIzaSyDrDdmRMzPZdInG6O9uTVrfslh82gXBcAc"

export default class CreatorCollection extends React.Component {

  constructor(props) {
    super(props)
    this.content = React.createRef()
    this.state = {
      selected_theme: "one",
      video_isopen: false,
      img_search_text: undefined,
      payge_created: false,
      copyLabelText: 'Copy to clipboard',
      input_errors: [false, false, false],
      error_indicator_mode: false,
      new_payge_data: undefined,
      userUid: undefined,
      isFileSelectOpen: true,
      collectionLogo: undefined,
      // customize panel
      isCustomizePanelOpen: false,
      currentThemeColorName: themeColors[0].name,
      isLoading: false,
      isPublishError: false,
      newPaygeData: undefined,
      currentCollectionViewStyle: 'grid',
      downloads: [],
      collectionTitle: undefined,
      collectionDescription: undefined,
    }
  }

  closeYouTubeModal = () => {
    if (this.state.video_isopen) {
      this.setState({video_isopen: false})
    }
  }

  // copying to clipboard
  copyLinkToClipboard = (link) => {
    let context = this
    navigator.permissions.query({name: "clipboard-write"}).then(result => {
      if (result.state == "granted" || result.state == "prompt") {
        // writing link to clipboard
        navigator.clipboard.writeText(link).then(function() {
          console.log("clipboard copied")
          // quick UI changes
          context.showCopyUIChanges()
        }, function() {
          console.log("clipboard error")
        });
      }
    });
  }
  showCopyUIChanges = () => {
    this.setState({copyLabelText: 'Copied'})
    setTimeout(() => {
      this.setState({copyLabelText: 'Copy to clipboard'})
    }, 500)
  }

  // When a file is selected from Google Picker
  onDriveSelectDataChange = (data) => {
    if (data.docs) {
      let { downloads } = this.state
      let ids = downloads.map(d => d.id)
      data.docs.map(doc => {
        // getting file info
        let fileId = doc.id  
        axios(`https://www.googleapis.com/drive/v2/files/${fileId}?key=${DRIVE_API_KEY}`)
        .then((result) => {
          if (result.status === 200 && ids.indexOf(fileId) === -1) {
            downloads.push({ id: fileId, driveFile: result.data, fileProvider: 'GoogleDrive', name: '', fileName: result.data.title })
          }
        })
      })
      // saving the new downloads
      this.setState({
        downloads: downloads
      })
    }
  }
  // When a file is selected from Dropbox Chooser
  onDropboxChooseDataChange = (files) => {
    if (files) {
      const { downloads } = this.state
      let ids = downloads.map(d => d.id)
      let dropboxFiles = files.map(file => {
        if (ids.indexOf(file.id) === -1) {
          downloads.push({ id: file.id, dropboxFile: file, fileProvider: 'Dropbox', name: '', fileName: file.name })
        }
      })
      this.setState({ downloads: downloads })
    }
  }
  // removing files
  handleFileRemove = (id) => {
    const { downloads } = this.state
    let ids = downloads.map(d => d.id)
    downloads.splice(ids.indexOf(id), 1)
    this.setState({ downloads: downloads })
  }
  // on new landing logo
  handleCollectionLogoChange = (event) => {
    this.setState({
      collectionLogo: event.target.files[0]
    })
  }
  // handle file name changes 
  handleFileNameChange = (newText, id) => {
    const { downloads } = this.state
    const index = downloads.map(d => d.id).indexOf(id)
    downloads[index].name = newText
    this.setState({downloads: downloads})
  }
  handleCollectionTitleChange = (text) => {
    this.setState({collectionTitle: text})
  }
  handleCollectionDescriptionChange = (text) => {
    this.setState({collectionDescription: text})
  }

  // publish click handler
  onPublishClick = () => {
    const { downloads, collectionTitle, collectionDescription, collectionLogo, currentThemeColorName, 
      currentCollectionViewStyle, isCustomizePanelOpen, userUid, isLoading } = this.state

    // loading check
    if (isLoading) { return false }
    // closing customize panel
    if (isCustomizePanelOpen) { this.setState({isCustomizePanelOpen: false}) }
    // checking for values
    if (downloads.length > 0 && collectionTitle && collectionDescription) {
      this.setState({isLoading: true})
      // sending new payge request

      // formating downloads
      let files = downloads.map(download => {
        let name = download.name && download.name.trim() !== "" ? download.name : download.fileName
        download.name = name
        return download
      })

      let url = `${API_URL}/payge/collection/new`
      let postData = new FormData()
      postData.append('collectionTitle', collectionTitle)
      postData.append('collectionDescription', collectionDescription)
      postData.append('collectionThemeColor', currentThemeColorName)
      postData.append('collectionViewStyle', currentCollectionViewStyle)
      postData.append('files', JSON.stringify(files))
      postData.append('ownerUser', userUid)
      if (collectionLogo) { postData.append('collectionLogo', collectionLogo) }

      // loading indicator
      window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);

      // calling the API
      axios({
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: postData
      })
        .then((result) => {
          if (result.status === 200) {
            if (result.data.status === "success") {
              window.open(`${result.data.payge.paygeUrl}?new_payge=true`, '_blank')
              // setTimeout(()=>{window.open('/dashboard', '_self')}, 500)
            }
          }
          return
        },
        (error) => {
          this.setState({
            isLoading: false,
          })
        })

    } else {
      this.setState({isPublishError: true})
      setTimeout(() => {
        this.setState({isPublishError: false})
      }, 2000)
    }
  }

  componentWillMount() {
    let self = this
    // getting auth user
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        self.setState({userUid: user.uid})
      } else {
        // User is signed out.
        window.open('/', '_self')
        return
      }
    })
  }

  render() {
    const { video_isopen, payge_created, userUid, copyLabelText, input_errors, new_payge_data, isFileSelectOpen, 
      error_indicator_mode, collectionLogo, isPublishError, isCustomizePanelOpen, currentThemeColorName, isLoading,
      currentCollectionViewStyle, downloads, collectionTitle, collectionDescription } = this.state
  
    // setting up get payge element
    let getPaygeElemenet = false
    if (isLoading) {
      getPaygeElemenet = (
        <>
          <div class="shimmer-container">
            <div className="name shimmer" />
            <div className="description shimmer" />
            <div className="description shimmer" />
            <div className="description shimmer" />
            <div className="description shimmer short" />
          </div>
        </>
      )
    } else if (new_payge_data) {
      getPaygeElemenet = (
        <>
          <div className="success-container">
            <span className="done-text">Your download Payge is ready!</span>
            <div className="link-container">
              <a href={new_payge_data.paygeUrl} target="_blank" style={{textDecoration: 'none'}}>
                <span className="link"><span className="payge-url-text">Payge Link —&nbsp;</span><b>{new_payge_data.paygeUrl}</b></span>
              </a>
              <span className="copy" onClick={()=>this.copyLinkToClipboard(new_payge_data.paygeUrl)}>{copyLabelText}</span>
            </div>
          </div>
        </>
      )
    }

    // getting progress
    let progressPercent = 0
    if (collectionTitle && collectionTitle.trim() !== "") { progressPercent += 30 }
    if (collectionDescription && collectionDescription.trim() !== "") { progressPercent += 30 }
    if (downloads && downloads.length > 0) { progressPercent += 40 }
 
    return (
      <>
        {
          userUid ? (
            <div onClick={this.closeYouTubeModal.bind(this)} id="creator-pro">
              <section className="pro-dashboard-topbar">
                <div className="logo">
                  <a href="/dashboard" style={{display: 'flex'}}>
                    <img src={logo} className="logo-img" />
                  </a>
                  <a href="/dashboard" style={{textDecoration: 'none'}}>
                    <span className="page-title">Payge</span>
                  </a>
                  <span className="creator-title">Creator</span>
                </div>
                <div style={{display:'flex',alignSelf:'center'}}>
                  <ul className="extra-options">
                    <li onClick={()=>{
                        if (!isLoading && !isCustomizePanelOpen) {
                          this.setState({isCustomizePanelOpen: true})
                        }
                      }}>
                      <MoreHoriz className="icon"/>Customize
                    </li>
                  </ul>
                  <div className={isLoading ? "publish-btn loading":"publish-btn"} onClick={this.onPublishClick.bind(this)}>
                    <span>{isLoading ? "Publishing...": "Publish"}</span>
                    {
                      isLoading ? <HourglassEmptyRounded className="icon" /> : <DoneAll className="icon" />
                    }
                  </div>
                </div>
              </section>
              <div className="topbar-progress" style={{width: `${progressPercent}%`}} />

              <>
                <div className="mobile-support">You'll need the desktop version to create a new Payge. We'll be bringing mobile real soon! :)</div>
                
                <CollectionPayge 
                  isEditing={true}
                  onDropboxChooseDataChange={this.onDropboxChooseDataChange}
                  onDriveSelectDataChange={this.onDriveSelectDataChange}
                  handleFileNameChange={this.handleFileNameChange}
                  handleCollectionTitleChange={this.handleCollectionTitleChange}
                  handleCollectionDescriptionChange={this.handleCollectionDescriptionChange}
                  handleCollectionLogoChange={this.handleCollectionLogoChange}
                  handleFileRemove={this.handleFileRemove}
                  collectionLogo={collectionLogo}
                  collectionTitle={collectionTitle}
                  collectionDescription={collectionDescription}
                  // customizations
                  collectionViewStyle={currentCollectionViewStyle}
                  themeColorName={currentThemeColorName}
                  downloads={downloads} />

              </>

              <Modal
                isOpen={ video_isopen }
                ariaHideApp={false}
                contentLabel="How to?"
                style={yt_modal_styles}
                id="yt-video-modal">
                <div id="headerPopup" class="mfp-hide embed-responsive embed-responsive-21by9">
                  <iframe class="embed-responsive-item" width="854" height="480" src="https://www.youtube.com/embed/WiAS15V6sXs?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
              </Modal>

              {
                isCustomizePanelOpen ? (
                  <div className="customize-container">
                    <span className="customize-title">Change theme color</span>
                    <span className="customize-description">Pick a theme color to change color of the sidebar and external links</span>
                    <ul className="theme-colors">
                      {
                        themeColors.map(color => {
                          let liStyles = ''
                          if (color.name === currentThemeColorName) {
                            liStyles = "active"
                          }
                          return (
                            <li onClick={()=>this.setState({currentThemeColorName: color.name})} className={liStyles}>
                              <div style={{background:`rgb(${color.color[0]}, ${color.color[1]}, ${color.color[2]})`}}/>
                            </li>
                          )
                        })
                      }
                    </ul>
                    <span className="customize-title">Change Collection Layout</span>
                    <span className="customize-description">Select a layout of your choice for the downloads in your collection</span>
                    <ul className="view-styles">
                      <li className={currentCollectionViewStyle === "grid" ? "active":"inactive"}
                        onClick={()=>this.setState({currentCollectionViewStyle: 'grid'})}>
                        <div className="grid faded"/><div className="grid"/><div className="grid faded"/>
                      </li>
                      <li className={currentCollectionViewStyle === "list" ? "active":"inactive"}
                        onClick={()=>this.setState({currentCollectionViewStyle: 'list'})}>
                        <div className="list faded"/><div className="list"/><div className="list faded"/>
                      </li>
                    </ul>

                    <span className="customize-action-btn" onClick={()=>this.setState({isCustomizePanelOpen: false})}>Done</span>
                  </div>
                ) : false
              }

              {/* <section id="footer-section">
                <img src={yashLogo} className="yash-logo" />
              </section> */}
            </div>
          ) : false
        }

      </>
    )
  }

}